import { getElementInfoByProp } from '../../models/element';
import { Menu } from '../../models/menu';

export class MenuUtils {
  static convertMenuItems(menu: Menu[], elementId: number, siteType: string): Menu[] {
    const baseUrl = getElementInfoByProp('elementId', elementId)?.url;

    const mapMenuItem = (item: Menu) => ({
      ...item,
      id: item.menuId,
      navigateUrls: item.navigateUrl ? [baseUrl, item.navigateUrl] : null,
      description: this.getMenuLabel(item.description, siteType)
    });

    return menu
      .filter(({ currentUserCanAccess }) => currentUserCanAccess)
      .map(item => ({
        ...mapMenuItem(item),
        childMenus: item.childMenus?.map(mapMenuItem) ?? []
      }));
  }

  static getMenuLabel(childMenu: string, siteType: string): string {
    if (childMenu === MenuOption.Transactions) {
      return `${siteType} ${childMenu}`;
    }
    return childMenu;
  }
}

const MenuOption = {
  Dashboard: 'Dashboard',
  Transactions: 'Transactions'
};
